<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden bg-gray-50 dark:bg-gray-900">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row flex-0 items-start sm:items-center justify-between p-6 sm:px-8 sm:py-6 bg-default dark:bg-transparent shadow-sm">
        <div class="flex-1 min-w-0 mb-4 sm:mb-0">
            <div class="flex items-center">
                <a class="inline-flex items-center -ml-1.5 text-secondary font-medium" [routerLink]="'/profile-dashboard'">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                    <span class="ml-1">Back</span>
                </a>
            </div>
            <div class="mt-2">
                <h1 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Reports Center
                </h1>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Generate and download detailed reports from your data
                </p>
            </div>
        </div>
    </div>
    <br>
    <!-- Main Content -->
     <div *ngIf="!canViewReports" class="w-full py-8 text-center">
    <h2 class="text-2xl font-bold text-gray-600 mb-2">Access Denied</h2>
    <p class="text-gray-500">You don't have permission to view reports.</p>
  </div>
    <div class="flex flex-col flex-auto p-4 sm:p-6 overflow-y-auto">
        <!-- Filters Card -->
        <div *ngIf="canViewReports" class="mb-6 p-4 sm:p-6 rounded-lg shadow bg-white dark:bg-gray-800">
            <div class="flex items-center justify-between mb-4">
                <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Filters</h2>
                <button mat-button color="accent" (click)="resetFilters()">
                    Reset
                </button>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                
                <!-- Program Filter -->
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Program</mat-label>
                    <mat-select [(value)]="selectedProgram" (selectionChange)="onProgramChange()">
                        <mat-option value="">All Programs</mat-option>
                        <mat-option *ngFor="let program of lstPrograms" [value]="program.Id">
                            {{ program?.Name || 'Unnamed Program' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                
                <!-- Report Type Filter -->
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Report Type</mat-label>
                    <mat-select [(value)]="selectedReportType">
                        <mat-option value="attendance">Attendance</mat-option>
                        <mat-option value="payment">Payment</mat-option>
                        <mat-option value="parentChildren">Parent & Children</mat-option>
                        <mat-option value="registration">Registration</mat-option>
                        <mat-option value="all">All Reports</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        
        <!-- Reports Cards -->
        <div class="grid grid-cols-1 gap-6">
            <!-- Attendance Reports Card -->
            <div *ngIf="showAttendanceReport" class="report-card p-4 sm:p-6 rounded-lg shadow bg-white dark:bg-gray-800">
                <div class="flex items-center justify-between mb-4">
                    <div>
                        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Attendance Report</h2>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            {{filteredAttendance.length}} records available
                        </p>
                    </div>
                    <mat-icon class="text-accent">how_to_reg</mat-icon>
                </div>
                
                <div class="space-y-4">
                                        <div *ngIf="attendanceSummary" class="mt-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div class="grid grid-cols-2 gap-2 text-sm">
                            <div class="text-gray-500 dark:text-gray-400">Total Students:</div>
                            <div class="font-medium">{{attendanceSummary.total}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Present:</div>
                            <div class="text-green-600 dark:text-green-400 font-medium">{{attendanceSummary.present}} ({{attendanceSummary.presentPercentage}}%)</div>
                            <div class="text-gray-500 dark:text-gray-400">Absent:</div>
                            <div class="text-red-600 dark:text-red-400 font-medium">{{attendanceSummary.absent}} ({{attendanceSummary.absentPercentage}}%)</div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-end sm:flex-row gap-3">
                        <button mat-raised-button color="primary" (click)="downloadAttendanceReport()" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download CSV
                        </button>
                        <button mat-raised-button (click)="downloadAttendanceReport('pdf')" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download PDF
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Payment Reports Card -->
            <div *ngIf="showPaymentReport" class="report-card p-4 sm:p-6 rounded-lg shadow bg-white dark:bg-gray-800">
                <div class="flex items-center justify-between mb-4">
                    <div>
                        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Payment Report</h2>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            {{filteredPayments.length}} records available
                        </p>
                    </div>
                    <mat-icon class="text-accent">payments</mat-icon>
                </div>
                
                <div class="space-y-4">
                                        <div *ngIf="paymentSummary" class="mt-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div class="grid grid-cols-2 gap-2 text-sm">
                            <div class="text-gray-500 dark:text-gray-400">Total Revenue:</div>
                            <div class="font-medium">{{paymentSummary.totalRevenue | currency}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Collected:</div>
                            <div class="text-green-600 dark:text-green-400 font-medium">{{paymentSummary.collected | currency}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Pending:</div>
                            <div class="text-yellow-600 dark:text-yellow-400 font-medium">{{paymentSummary.pending | currency}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-end sm:flex-row gap-3">
                        <button mat-raised-button color="primary" (click)="downloadPaymentReport()" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download CSV
                        </button>
                        <button mat-raised-button (click)="downloadPaymentReport('pdf')" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download PDF
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Parent & Children Report Card -->
            <div *ngIf="showParentChildrenReport" class="report-card p-4 sm:p-6 rounded-lg shadow bg-white dark:bg-gray-800">
                <div class="flex items-center justify-between mb-4">
                    <div>
                        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Parent & Children Report</h2>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            {{filteredParentChildren.length}} records available
                        </p>
                    </div>
                    <mat-icon class="text-accent">family_restroom</mat-icon>
                </div>
                
                <div class="space-y-4">
                                        <div *ngIf="parentChildrenSummary" class="mt-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div class="grid grid-cols-2 gap-2 text-sm">
                            <div class="text-gray-500 dark:text-gray-400">Total Parents:</div>
                            <div class="font-medium">{{parentChildrenSummary.totalParents}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Total Children:</div>
                            <div class="font-medium">{{parentChildrenSummary.totalChildren}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Active Registrations:</div>
                            <div class="text-green-600 dark:text-green-400 font-medium">{{parentChildrenSummary.activeRegistrations}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-end sm:flex-row gap-3">
                        <button mat-raised-button color="primary" (click)="downloadParentChildrenReport()" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download CSV
                        </button>
                        <button mat-raised-button (click)="downloadParentChildrenReport('pdf')" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download PDF
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Registration Report Card -->
            <div *ngIf="showRegistrationReport" class="report-card p-4 sm:p-6 rounded-lg shadow bg-white dark:bg-gray-800">
                <div class="flex items-center justify-between mb-4">
                    <div>
                        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Registration Report</h2>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            {{filteredRegistrations.length}} records available
                        </p>
                    </div>
                    <mat-icon class="text-accent">assignment</mat-icon>
                </div>
                
                <div class="space-y-4">
                    <div *ngIf="registrationSummary" class="mt-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                        <div class="grid grid-cols-2 gap-2 text-sm">
                            <div class="text-gray-500 dark:text-gray-400">Total Registrations:</div>
                            <div class="font-medium">{{registrationSummary.total}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Active:</div>
                            <div class="text-green-600 dark:text-green-400 font-medium">{{registrationSummary.active}}</div>
                            <div class="text-gray-500 dark:text-gray-400">Cancelled:</div>
                            <div class="text-red-600 dark:text-red-400 font-medium">{{registrationSummary.cancelled}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-end sm:flex-row gap-3">
                        <button mat-raised-button color="primary" (click)="downloadRegistrationReport()" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download CSV
                        </button>
                        <button mat-raised-button (click)="downloadRegistrationReport('pdf')" class="flex">
                            <mat-icon class="mr-2">download</mat-icon>
                            Download PDF
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>